var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasknav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.7945V17.1425C4 18.2626 4 18.823 4.21799 19.2508C4.40973 19.6272 4.71547 19.9328 5.0918 20.1246C5.5192 20.3424 6.07899 20.3424 7.19691 20.3424H16.8031C17.921 20.3424 18.48 20.3424 18.9074 20.1246C19.2837 19.9328 19.5905 19.6272 19.7822 19.2508C20 18.8234 20 18.2639 20 17.1459V11.7945C20 11.2602 19.9995 10.9929 19.9346 10.7442C19.877 10.5239 19.7825 10.3154 19.6546 10.1269C19.5102 9.9143 19.3096 9.73797 18.9074 9.38611L14.1074 5.18611C13.3608 4.53283 12.9875 4.20635 12.5674 4.08211C12.1972 3.97263 11.8026 3.97263 11.4324 4.08211C11.0126 4.20626 10.6398 4.53242 9.89436 5.18472L5.09277 9.38611C4.69064 9.73798 4.49004 9.9143 4.3457 10.1269C4.21779 10.3154 4.12255 10.5239 4.06497 10.7442C4 10.9929 4 11.2602 4 11.7945Z",
    stroke: "#3A3428",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasknav);
export default __webpack_public_path__ + "static/media/tasknav.dc1ce4957f5ba99e3e79c9572faf99ab.svg";
export { ForwardRef as ReactComponent };